import { c as _c } from "react/compiler-runtime";
import { SecondaryButton } from '@systemeio/ui';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { FC } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUserDomains from 'shared/hooks/use-user-domains';
import { OpenInNewIcon } from '@systemeio/ui/icons';
const StoreViewButton: FC = () => {
  const $ = _c(12);
  const {
    t
  } = useLocoTranslation();
  const {
    storeId
  } = useStoreQuery();
  const {
    data: storeView
  } = useStore(storeId);
  const {
    userDomains
  } = useUserDomains();
  let t0;
  if ($[0] !== storeView?.domainId || $[1] !== userDomains) {
    t0 = userDomains?.find(domain => domain.id === storeView?.domainId);
    $[0] = storeView?.domainId;
    $[1] = userDomains;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const domain_0 = t0;
  const url = domain_0 && storeView ? `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domain_0.name}/${storeView.path}` : "";
  const t1 = !url;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OpenInNewIcon className="fill-text-primary group-hover:fill-background-secondary main-transition-colors" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("global.view");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="hidden sm:inline">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4 || $[10] !== url) {
    t5 = <SecondaryButton as={LinkWithoutPrefetch} target="_blank" rel="noreferrer" href={url} aria-disabled={t1}>{t2}{t4}</SecondaryButton>;
    $[8] = t1;
    $[9] = t4;
    $[10] = url;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default StoreViewButton;